<template>
  <div
    class="wave-dot"
    :class="{ 'is-large': isLarge }">
    <span class="dot" />
    <span class="dot" />
    <span class="dot" />
  </div>
</template>

<script>
export default {
  name: "WaveDotsLoader",
  props: {
    isLarge: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.wave-dot {
  position: relative;

  .dot {
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 4px;
    margin-right: 3px;
    background-color: color(gray01);
    animation: wave 0.65s linear infinite;
  }

  &.is-large {
    .dot {
      width: 6px;
      height: 6px;
      border-radius: 6px;
    }
  }
}

.wave-dot .dot:nth-child(2) {
  animation-delay: -0.55s;
}

.wave-dot .dot:nth-child(3) {
  animation-delay: -0.45s;
}

@keyframes wave {
  0%,
  60%,
  100% {
    transform: initial;
  }

  30% {
    transform: translateY(-5px);
  }
}
</style>
